import { getGreetingMessage } from "lib/utils/util";
import { FC } from "react";

interface SimpleGreetingProps {
  name: string;
}

const SimpleGreeting: FC<SimpleGreetingProps> = ({ name }) => {
  const greeting = getGreetingMessage();
  return (
    <h2>
      {greeting} <span className="fw-normal">{name}</span>
    </h2>
  );
};

export default SimpleGreeting;
